import React, { useRef } from 'react';
import cx from 'classnames';
// import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

import { useStateFromProp } from '~hooks/common';
import './style.scss';

const Context = React.createContext();

let collapsibleIdCounter = 0;
const getNextId = () => {
  collapsibleIdCounter += 1;
  return collapsibleIdCounter;
};

const Wrapper = ({ children, forScreen = null, className, ...props }) => {
  const [isExpanded, onChange] = useStateFromProp(props.isExpanded || false, props.onChange);
  const contentIdRef = useRef(`collapsible-content-${getNextId()}`);
  const contentId = contentIdRef.current;

  return (
    <Context.Provider value={[onChange, isExpanded, forScreen, contentId]}>
      <div
        className={cx('c-collapsible', {
          'c-collapsible--expanded': isExpanded,
          [`c-collapsible--for-${forScreen}`]: forScreen,
          [className]: !!className,
        })}
      >
        {children}
      </div>
    </Context.Provider>
  );
};

const Header = ({ children, className, iconAltText='' }) => {
  const [onChange, isExpanded, , contentId] = React.useContext(Context);

  return (
    <button
      type="button"
      className={cx('c-collapsible__header', {
        [className]: !!className,
      })}
      onClick={() => onChange(!isExpanded)}
      aria-expanded={isExpanded}
      aria-controls={contentId}
    >
      {children}
      {isExpanded ? (
        <img src="/images/chevron-down-solid-full.svg" alt={iconAltText} style={{transform: 'rotate(180deg)'}} className="c-collapsible__icon c-collapsible__icon--up" />
      ) : (
        <img src="/images/chevron-down-solid-full.svg" alt={iconAltText} className="c-collapsible__icon c-collapsible__icon--down" />
      )}
    </button>   
  );
};

const Content = ({ children, className }) => {
  const [, , , contentId] = React.useContext(Context);

  return (
    <div
      id={contentId}
      className={cx('c-collapsible__content', {
        [className]: !!className,
      })}
    >
      {children}
    </div>
  );
};

const ContentCollapsed = ({ children, className }) => {
  return (
    <div
      className={cx('c-collapsible__content-collapsed', {
        [className]: !!className,
      })}
    >
      {children}
    </div>
  );
};

export default {
  Wrapper,
  Header,
  Content,
  ContentCollapsed,
};
